<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="entry-title"><span>{{'About' | translate}}</span> {{'us' | translate}}</h2>
                <div class="breadcrumb">
                    <span>{{'here' | translate}}: </span>
                    <a routerLink="/Home"> {{'home' | translate}}</a>
                    <span class="crumbs-spacer"><i class="fa fa-angle-double-right"></i></span>
                    <span class="current">{{'about' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->

<!-- Start About Section  -->
<section class="about section">
    <div class="container">
        <div class="row">
            <div class="col-md-6 float-r">
                <!-- Classic Heading -->
                <h2 class="big-title">{{'about' | translate}}</h2>
                <p>
                    {{'pref' | translate}}
                </p>
                <p> 1 - {{'pref1' | translate}}</p>
                <p> 2 - {{'pref2' | translate}}</p>
                <p> 3 - {{'pref3' | translate}}</p>
                <div id="AboutReadMore" style="display:none">
                    <p>
                        {{'achive' | translate}}<br />
                    </p>
                    <p> 1. {{'achive1' | translate}}</p>
                    <p> 2. {{'achive2' | translate}}</p>
                    <p> 3. {{'achive3' | translate}}</p>
                    <p> 4. {{'achive4' | translate}}</p>
                    <p> 5. {{'achive5' | translate}}</p>
                    <p> 6. {{'achive6' | translate}}</p>

                </div>
                <div class="group-btn">
                    <a class="btn btn-effect" onclick="$('#AboutReadMore').toggle()">{{'knowMore' | translate}}</a>
                    <a routerLink="/" class="btn btn-wite">{{'projects' | translate}}</a>
                </div>
            </div>
            <div class="col-md-6">
                <div class="featured-thumb">
                    <img class="img-en" src="../../../assets/images/goals.png" alt="">
                    <img class="img-ar float-l" src="../../../assets/images/GoalsArabic.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About Section  -->

<!-- Start Banner Section -->
<div class="banner" style="background: url(../../../../assets/images/bg/bg1.jpg);">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="wrapper text-center">
                    <h1>{{'aboutSlogan' | translate}}</h1>
                    <p>{{'aboutDes' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Banner Section -->


<!-- Start Team Member Section -->
<!-- <div class="team section">
    <div class="container">
        <div class="heading">
            <div class="section-title"><a routerLink="/Team">{{'Team' | translate}} <span>{{'Members' | translate}}</span></a></div>
        </div>
        <p class="description text-center">{{'TeamDes' | translate}}
        </p>
        <div class="row">
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/eng-zuhair.jpg" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T1' | translate}}</h4>
                                <p>{{'T1D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/engzuhair68?fref=ts" class="facebook"><i
                                        class="fa fa-facebook"></i></a>

                                <a href="https://sa.linkedin.com/in/zuhair-wanli-5515a6102/en" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T1' | translate}}</h4>
                        <p>{{'T1D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img height="100" src="../../../assets/images/team/Tonsy1png.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T2' | translate}}</h4>
                                <p>{{'T2D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/tunisation" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/#" class="twitter"><i class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/+tunisation" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/tunisation" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T2' | translate}}</h4>
                        <p>{{'T2D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/Ahmed1.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T3' | translate}}</h4>
                                <p>{{'T3D' | translate}}</p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/goharyone?fref=ts" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/goharyone" class="twitter"><i
                                        class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/u/0/105524579950788841990" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/ahmed-gohary-25666951" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T3' | translate}}</h4>
                        <p>{{'T3D' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="team-member">
                    <div class="team-thumbnail">
                        <img src="../../../assets/images/team/zaki.png" alt="">
                        <div class="overlay">
                            <p class="text"></p>
                            <div class="info name">
                                <h4>{{'T4' | translate}}</h4>
                                <p>{{'T4D' | translate}} </p>
                            </div>
                            <div class="social-media">
                                <a href="https://www.facebook.com/zaki.eldsoque" class="facebook"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/zeko_Eldsoque" class="twitter"><i
                                        class="fa fa-twitter"></i></a>
                                <a href="https://plus.google.com/+ZakiEldsoque" class="google"><i
                                        class="fa fa-google-plus"></i></a>
                                <a href="https://eg.linkedin.com/in/zakieldsoque" class="linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="info">
                        <h4>{{'T4' | translate}}</h4>
                        <p>{{'T4D' | translate}}</p>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div> -->

<!-- Start Counter Section -->
<div id="counter" class="section" style="margin-bottom:0.1%">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item left-line">
                    <div class="icon">
                        <i class="icon-check">
                        </i>
                    </div>
                    <h5>
                        {{'CompletedProjects' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="180" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-clock">
                        </i>
                    </div>
                    <h5>
                        {{'HoursofWork' | translate}} <span>{{'Month' | translate}}</span>
                    </h5>
                    <hr>
                    <div class="timer" data-to="369" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-trophy">
                        </i>
                    </div>
                    <h5>
                        {{'AwardWinnigs' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="29" data-speed="5000">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="counter-item">
                    <div class="icon">
                        <i class="icon-heart">
                        </i>
                    </div>
                    <h5>
                        {{'SatisfiedClients' | translate}}
                    </h5>
                    <hr>
                    <div class="timer" data-to="149" data-speed="5000">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Client Section -->
<!-- <div class="client section">
    <div class="container">
        <div class="heading">
            <div class="section-title">Brands & <span>Clients</span></div>
        </div>
        <p class="description text-center">
            We in Aldawal dedicated to customer needs regulations after that the team studied a course of action within
            the organization taking into account the policies and the nature of work in the organization
        </p>
        <div class="row">
            <div id="client-logo" class="touch-carousel">
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-01.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-02.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-07.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-09.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-10.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-12.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-13.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-08.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-04.png" alt="" />
                        </a>
                    </div>
                </div>

                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-11.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-05.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-06.png" alt="" />
                        </a>
                    </div>
                </div>
                <div class="client-logo item">
                    <div class="client-item">
                        <a href="#">
                            <img src="../../../../assets/images/clients/logo-03.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div> -->
<!-- End Client Section -->